import React from 'react';

export const renderTokenLabel = (tagValue, tokenPrefix, tokenSuffix = '') => {
  const regEx = new RegExp(`(\\[${tokenPrefix})(.*)${tokenSuffix}]$`);
  const indexOfToken = tagValue.search(regEx);
  if (indexOfToken !== -1) {
    const displayObject = {};
    displayObject.name = tagValue.substring(0, indexOfToken - 1).trim();
    displayObject.mrn = tagValue
      .substring(
        indexOfToken + (tokenPrefix.length + 1),
        tagValue.length - (tokenSuffix.length + 1),
      )
      .trim();
    return (
      <React.Fragment>
        {displayObject.name} <em>({displayObject.mrn})</em>
      </React.Fragment>
    );
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/views/components/Search/PatientSearchUtils.jsx